import React__default from 'react';
import { styled } from 'styled-components';
import { isInDesktop } from '@fabric-app/compat';
import { platform } from '@todesktop/client-core';
import { getCompatPlatform } from '@fabric-app/compat/capabilities/platform';
import { openBrowserExternalUrl } from '@fabric-app/utils/url/openBrowserExternalUrl';

const openExternal = (url, target) => {
  if (getCompatPlatform().openExternal(url, target)) return;
  openBrowserExternalUrl(url, target);
};
const LinkExternal = styled.a.attrs((props) => {
  const { href, onClick } = props;
  const clickHandler = React__default.useMemo(() => {
    if (!href) {
      return onClick;
    }
    let url;
    try {
      url = new URL(href);
      if (!url) {
        throw new Error("Invalid URL");
      }
      if (![
        "http:",
        "https:",
        "mailto:",
        "fabric:"
      ].includes(url.protocol)) {
        throw new Error("Invalid protocol");
      }
    } catch {
      return (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick?.(e);
      };
    }
    const hrefSanitized = url.toString();
    return isInDesktop() ? (e) => {
      platform.os.openURL(hrefSanitized);
      e.stopPropagation();
      e.preventDefault();
      onClick?.(e);
    } : (e) => {
      e.stopPropagation();
      onClick?.(e);
    };
  }, [
    href,
    onClick
  ]);
  return {
    ...props,
    onClick: clickHandler,
    target: "_blank",
    rel: "noopener noreferrer"
  };
}).withConfig({
  displayName: "LinkExternal",
  componentId: "sc-ca985f2-0"
})([
  ``
]);

export { LinkExternal, openExternal };
//# sourceMappingURL=LinkExternal.js.map
